import { render, staticRenderFns } from "./PersonProvider.vue?vue&type=template&id=911f9d4e&scoped=true&"
import script from "./PersonProvider.vue?vue&type=script&lang=ts&"
export * from "./PersonProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911f9d4e",
  null
  
)

export default component.exports